import React, {CSSProperties, ReactNode} from 'react'

import Colors from '@utils/Colors.js'
import {zIndex} from '../styles.js'
import DevBranchBadge from './DevBranchBadge.js'
import {topNavSizes} from './styles.js'
import type {NavBarBranding} from './types.js'

export interface NavBarProps {
    branding?: NavBarBranding
    /** NavBarLinks and NavBarMenus, laid out from the left */
    children?: ReactNode
}

/** The bar at the top of the page with the logo and the links (NavBarLink, NavBarMenu). In development it shows the git branch. */
export default function NavBar({children, branding}: NavBarProps) {
    const style: CSSProperties = {
        position: 'fixed',
        top: 0,
        zIndex: zIndex.nav,
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: topNavSizes.height,
        fontSize: 16,
        color: Colors.textDark,
        background: Colors.backgroundWhite,
        boxShadow: '0 0 10px 0 rgba(0,0,0,0.1)'
    }

    return (
        <>
            <DevBranchBadge />
            <nav style={style}>
                {branding === undefined ?
                    <div style={{height: 32, width: 32, borderRadius: 4, marginLeft: 20, backgroundColor: Colors.grey20}} /> :
                    <img
                        style={{height: 32, marginLeft: 20}}
                        src={branding?.squareLogo || '/images/VELOYDLOGOSMALL.png'}
                        alt='Logo'
                    />
                }

                <div style={{display: 'flex', marginRight: 20, flex: 1, justifyContent: 'flex-start', height: '100%'}}>
                    {children}
                </div>
            </nav>
        </>
    )
}
